/** separate a hex string into 4 parts
 * @examples ```
 *  #012345 // [#, 01, 23, 45]
 *  #acb // [#, a, b, c]
 * ```
 * */
const REGEX_COLOR = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;

/** a number between 0 and 255 */
const DARK_NIVEL = 150;

enum COLLAPSE {
    "false" = 1,
    "true" = 2,
  };

function hexToRgb(hex): Array<number> {
    return hex.replace(REGEX_COLOR, (m, r, g, b) => '#' + r + r + g + g + b + b)
        .substring(1)
        .match(/.{2}/g)
        .map(x => parseInt(x, 16))
}

export class CustomState {
    id?: string;

    /** The translated state description */
    description: string;
    color: string;

    /** indicate if the state is default by system */
    isInternal: boolean;

    /** indicates sequence of columns in the kanban and whether they are collapsed */
    seq?: number;
    collapse?: boolean;

    /**  indicate to use white font color */
    isDark: boolean;

    isBudget: boolean;

    constructor(apiOb: any, isInternal = false) {
        this.id = apiOb.id || apiOb._id;
        this.description = apiOb.description;
        this.color = apiOb.color;
        this.isInternal = isInternal;
        const rgbArr = hexToRgb(apiOb.color);
        this.isDark = rgbArr && rgbArr.length && rgbArr.every(color => color < DARK_NIVEL);
        this.isBudget = apiOb.isBudget;
        this.seq = apiOb.seq;
        this.collapse = apiOb.collapse != COLLAPSE.false;
    }

    toAPI(): Object {
        return {
            "seq": this.seq,
            "collapse": this.collapse ? COLLAPSE.true : COLLAPSE.false,
            "color": this.color,
            "description": this.description,
            "isBudget": this.isBudget
        }
    }
}
